import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../services/admin.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms'
import Swal from 'sweetalert2';
import { Location } from '@angular/common';


@Component({
  selector: 'app-add-mapping-form',
  templateUrl: './add-mapping-form.component.html',
  styleUrls: ['./add-mapping-form.component.scss']
})
export class AddMappingFormComponent implements OnInit {
  mappingForm: FormGroup;
  cseList = [];
  facilityList = [];
  queryParams: any;
  facilityParams: string;
  submitBtnText = 'CONFIRM MAPPING';
  // prev_user_id: any;
  isUpdate: boolean = false;
  originalFacilityList: any[];
  cseParams: string;
  selectedFacility: any = [];
  constructor(private router: Router,
    private adminService: AdminService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private location: Location,
  ) {
    this.queryParams = this.route.snapshot.queryParams;
    let q = Object.keys(this.queryParams)
    if (q.length > 0) {
      let decodedStr = atob(`${q[0]}`);
      // console.log('qq', decodedStr);
      let properties = decodedStr.split('&');
      let obj = {};
      properties.forEach(function (property) {
        let tup = property.split('=');
        obj[tup[0]] = tup[1];
      });
      this.queryParams = obj;
    }

    // console.log('after decrypted in mapping form', this.queryParams);
    if (this.queryParams?.cseId) {    //Condition for update
      this.isUpdate = true;
      this.submitBtnText = 'UPDATE MAPPING'
    }
  }

  ngOnInit(): void {
    this.mappingForm = this.formBuilder.group({
      cse_id: ["", Validators.required],
      facility_id: [""]
    })

    if (this.queryParams.cseId !== undefined) {
      this.facilityParams = `cse_mapped=false&cse_id=${this.queryParams.cseId}&is_payment=true`
      // this.facilityParams = ''                   // If prefill needed then we need to give all option so that it can set. Because we will be setting that value whose are alreday mapped. So we cannot use this params(cse_mapped=false) here.
      this.cseParams = `cse_id=${this.queryParams.cseId}&mapped=false&status=1`;
    } else {
      this.facilityParams = 'cse_mapped=false'      //Only those data will show whose are not mapped yet
      this.cseParams = 'mapped=false&status=1';
    }

    this.adminService.getCSEListing(this.cseParams, sessionStorage.getItem("token")).subscribe((response: any) => {
      console.log(response);
      this.cseList = response?.data;
    })

    this.adminService.getFacilityListing(`${this.facilityParams}`, sessionStorage.getItem("token")).subscribe((response: any) => {
      console.log(response);
      this.facilityList = response?.data;
      this.originalFacilityList = this.facilityList;
    })

    if (this.queryParams.cseId !== undefined) {
      let id = `${this.queryParams.cseId}`
      let params = 'limit=10';
      this.adminService.mappedCseFacility(id, params, sessionStorage.getItem("token")).subscribe((response: any) => {
        console.log(response['data']);
        // console.log('facility id', response['data'][0]?.users[0]?.id);

        this.mappingForm.patchValue({
          cse_id: response.data[0].cse.id
        })

        // console.log(response.data[0].cse.id);


        // console.log(response.data.map((item) => item.id));

        this.mappingForm.patchValue({
          facility_id: response.data.length >= 0 ? response.data.map((item) => item.id) : []    //If field is mult-select then use [] to provide values
        })

        // this.prev_user_id = response['data'][0]?.users.map((item: any) => item.id);
        // setTimeout(()=>{
        //   this.mappingForm.patchValue({
        //     facility_id:response['data'][0]?.users[0]?.id
        //   })
        // }, 3000)

      })
    }

  }

  backIconClick() {
    // this.router.navigateByUrl('admin/cse-mapped-list');
    this.location.back();
  }

  cancelClick() {
    // this.router.navigateByUrl('admin/cse-mapped-list');
    this.location.back();
  }

  submitForm() {
    console.log(this.mappingForm);

    // let payload = this.mappingForm.value;

    // if (this.queryParams.cseId !== undefined) {        //To Update
    //   payload = { cse_id: this.mappingForm.value.cse_id, new_user_id: this.mappingForm.value.facility_id, prev_user_id: this.prev_user_id }
    //   this.adminService.updateCseFacility(payload, sessionStorage.getItem("token")).subscribe((response: any) => {
    //     console.log(response);
    //     Swal.fire('Success', 'Data Updated Successfully', 'success').then(() => {
    //       this.location.back();
    //     })
    //   },
    //     (error) => {
    //       Swal.fire('Error', `${error.error.message}`, 'error')
    //     }
    //   )
    // } else {                                            //To Submit
    this.adminService.mapCseFacility(this.mappingForm.value, sessionStorage.getItem("token")).subscribe((response: any) => {
      console.log(response);
      Swal.fire('Success', 'Data Mapped Successfully', 'success').then(() => {
        this.location.back();
      })
    },
      (error) => {
        // console.log(error.error.message);
        Swal.fire('Error', `${error.error.message}`, 'error')
      }
    )
    // }
  }

  facilitySelected(event) {
    console.log('Event', event.value)
    this.selectedFacility = event.value;
  }

  searchOnDropdown(value) {
    let inputText = value.toLowerCase();

    if (value !== '') {
      //data matches with search text and data should not be already selected
      this.facilityList = this.originalFacilityList.filter((item) =>  item.facility_name.toLowerCase().includes(inputText) && !this.selectedFacility.includes(item.id));

      //For adding previously selected values.
      let previousSelected = this.originalFacilityList.filter((item) => this.selectedFacility.includes(item.id));
      previousSelected.map((item) => this.facilityList.push(item));
    } else {
      this.facilityList = this.originalFacilityList;
    }
    // console.log('facilityList', this.facilityList, inputText);
  }
}
